<template>
	<section class="container-precadastro">
		<!--    <div class="actions-precadastro" /> -->
		<div class="header-empresa">
			<div class="empresa-resume">
				<div class="empresa-details">
					<div class="left_content">
						<div class="top-left-content">
							<div class="image-component">
								<TextToInitials
									:data="data.fantasia"
									width="100px"
									height="100px"
									background-color="#f44336"
									align-items="center"
									justify-content="center"
									border-radius="5px"
									font-weight="bold"
									font-size="20px"
								/>
							</div>
							<div class="resume-empresa">
								<div class="box-subtitle-empresa">
									<span class="criacao-empresa-box">
										Criada em {{ data.dtanascfund }}
										<k-tag
											:title="returnElapsedTime(data.empresatempo)"
											padding="2px 12px 2px 12px"
											color="#5a189a"
											font-size="9px"
											font-weight="600"
										/>
									</span>
									<h1>{{ data.nomerazao }}</h1>
								</div>

								<div class="label-buttons">
									<Button
										title="Editar"
										margin-right="5px"
										width="70px"
										font-size="10px"
										:icon="{
											type: 'check-circle',
											size: '12px',
											color: '#000000',
										}"
										:disabled="false"
										border-radius="5px"
										@click="editAction()"
									/>

									<Button
										title="Arquivar"
										margin-right="5px"
										width="70px"
										font-size="10px"
										:icon="{
											type: 'archive',
											size: '12px',
											color: '#000000',
										}"
										:disabled="data.status === 2"
										border-radius="5px"
										@click="archive({ id: [data.id], motivo: 2 }, data.situacao, data.status !== 2)"
									/>
								</div>
							</div>
						</div>
						<div class="button-lef-content">
							<k-tag-custom
								:icon="{
									type: 'book',
									size: '20px',
									styles: {
										padding: 'unset',
										marginRight: '10px',
										display: 'flex',
										alignItems: 'center',
									},
								}"
								:data="{
									title: 'RGIE',
									data: data.rgie,
									styles: {
										display: 'flex',
										flexDirection: 'column',
									},
								}"
								padding="20px"
								color="#d80032"
								width="40%"
								font-size="10px"
								margin-top="20px"
								margin-right="20px"
								height="45px"
								align-items="center"
							/>
							<k-tag-custom
								:icon="{
									type: 'trending-up',
									size: '20px',
									styles: {
										padding: 'unset',
										marginRight: '10px',
										display: 'flex',
										alignItems: 'center',
									},
								}"
								:data="{
									title: 'CNAE',
									data: data.cnae,
									styles: {
										display: 'flex',
										flexDirection: 'column',
									},
								}"
								color="#2d00f7"
								width="40%"
								padding="20px"
								margin-top="20px"
								font-size="10px"
								height="45px"
								align-items="center"
							/>
						</div>
					</div>
					<div class="right_side">
						<div class="rows-details">
							<span class="label-title">
								<feather type="user" size="14px" class="icon-label" />
								<span>Fantasia</span>
							</span>
							<span>
								{{ data.fantasia ? data.fantasia : 'Não Informado' }}
							</span>
						</div>
						<div class="rows-details">
							<span class="label-title">
								<feather type="briefcase" size="14px" class="icon-label" />
								<span>CNPJ</span>
							</span>
							<span>
								{{ data.cnpj ? data.cnpj : 'Não Informado' }}
							</span>
						</div>

						<div class="rows-details">
							<span class="label-title">
								<feather type="alert-circle" size="14px" class="icon-label" />
								<span>Sintegra / RF</span>
							</span>
							<span>
								<Sintegra
									:data="
										getSintegraStatus({
											sintegrastatus: data.sintegrastatus,
											receitastatus: data.receitastatus,
										})
									"
								/>
							</span>
						</div>

						<div class="rows-details">
							<span class="label-title">
								<feather type="at-sign" size="14px" class="icon-label" />
								<span>Email</span>
							</span>
							<span>
								<a class="email_link" :href="`mailto: ${data.email}`">
									{{ data.email }}
								</a>
							</span>
						</div>
						<div class="rows-details">
							<span class="label-title">
								<feather type="map" size="14px" class="icon-label" />
								<span>Cidade</span>
							</span>
							<span>
								{{ data.cidade ? data.cidade : 'Não Informado' }}
							</span>
						</div>

						<div class="rows-details">
							<span class="label-title">
								<feather type="phone-call" size="14px" class="icon-label" />
								<span>Telefone</span>
							</span>
							<span>
								<a class="email_link" :href="`tel:${data.fone1}`">
									{{ data.fone1 ? formataNumeroTelefone(data.fone1) : 'Não Informado' }}
								</a>
							</span>
						</div>
					</div>
				</div>
				<div
					class="box-details-cadastro"
					:style="retStyles(data.situacao === -2 ? 5 : data.situacao === -1 ? 6 : data.situacao)"
				>
					<div class="detais-top-cadastro">
						<span class="details-top-title">Status Cadastro</span>
						<Kstatus :data="data.situacao === -2 ? 5 : data.situacao === -1 ? 6 : data.situacao" />
					</div>
					<div>
						<span v-if="data.origemcadastro" class="row-cad-status">
							<span>Origem</span>
							<span class="observacao-text">
								{{
									data.origemcadastro
										? data.origemcadastro === 1
											? 'Ecommerce'
											: '~'
										: 'Não Informado'
								}}</span>
						</span>
						<span class="row-cad-status">
							<span>Solicitação</span>
							<span>
								{{
									data.status === 1 ? 'Ativo' : data.status === 2 ? 'Arquivado' : 'Inativo'
								}}</span>
						</span>
						<span v-if="data.motstatus" class="row-cad-status">
							<span>Motivo</span>
							<span> {{ data.motstatus }}</span>
						</span>
						<span v-if="data.created_at" class="row-cad-status">
							<span>Data Criação</span>
							<span class="observacao-text"> {{ data.created_at }}</span>
						</span>
						<span v-if="data.dtaultconsultasintegra" class="row-cad-status">
							<span>Data Últ. Consulta Sintegra</span>
							<span class="observacao-text">
								{{ dateTimetoDateNoLocale(data.dtaultconsultasintegra) }}</span>
						</span>
						<span v-if="data.integracao_id" class="row-cad-status">
							<span>Id Integração</span>
							<span class="observacao-text"> {{ data.integracao_id }}</span>
						</span>
						<span v-if="data.observacao" class="row-cad-status">
							<span>Observação</span>
							<span class="observacao-text"> {{ data.observacao }}</span>
						</span>
						<span v-if="data.dadosinseridos" class="row-cad-status">
							<span>Origem Dados</span>
							<span class="observacao-text">
								{{
									data.dadosinseridos
										? data.dadosinseridos == 1
											? 'Sintegra / Receita'
											: 'Inseridos manualmente'
										: 'Não Informado'
								}}</span>
						</span>
					</div>
				</div>
			</div>
		</div>
		<div class="box-detalhes">
			<div class="socios-box">
				<span class="socios-title">Sócios</span>
				<div class="socio-row">
					<span>
						{{ data.nomesocio1 ? data.nomesocio1 : 'Não Informado' }}
					</span>
					<span>
						{{ data.cnpjcpfsocio1 ? data.cnpjcpfsocio1 : 'Não Informado' }}
					</span>
				</div>
				<div class="socio-row">
					<span>
						{{ data.nomesocio2 ? data.nomesocio2 : 'Não Informado' }}
					</span>
					<span>
						{{ data.cnpjcpfsocio2 ? data.cnpjcpfsocio2 : 'Não Informado' }}
					</span>
				</div>
				<div class="socio-row">
					<span>
						{{ data.nomesocio3 ? data.nomesocio3 : 'Não Informado' }}
					</span>
					<span>
						{{ data.cnpjcpfsocio3 ? data.cnpjcpfsocio3 : 'Não Informado' }}
					</span>
				</div>
			</div>

			<div class="detalhes-box">
				<span class="socios-title">Detalhes</span>
				<b-collapse
					v-for="(collapse, index) of collapses"
					:key="index"
					class="show"
					animation="slide"
					:open="isOpen == index"
					@open="isOpen = index"
				>
					<template #trigger="props">
						<div class="card-header" role="button">
							<p class="card-header-title">
								{{ collapse.title }}
							</p>
							<a class="card-header-icon">
								<b-icon :icon="props.open ? 'menu-down' : 'menu-up'" />
							</a>
						</div>
					</template>
					<div class="card-content">
						<div>
							<span v-if="!collapse.children" class="content">
								{{ collapse.text }}
							</span>

							<div
								v-for="(collapse_child, index_child) of collapse.children"
								:key="index_child"
								class="rows-details-info"
							>
								<span v-if="collapse_child.text" class="row-collaps-item">
									<span class="label-title">
										<feather :type="collapse_child.icon" size="14px" class="icon-label" />
										<span>{{ collapse_child.title }}</span>
									</span>
									<span class="rows-details-addres">
										{{ collapse_child.text }}
									</span>
								</span>
							</div>
						</div>
					</div>
				</b-collapse>
			</div>
		</div>
		<div v-if="situacaoLog.length > 0" class="log-box">
			<span class="socios-title">Histórico</span>
			<TimeLine background-color="#FFF" min-height="100px" :data="cadastro_situacoes_log" />
		</div>

		<OptModal v-if="closemodal" @close="closemodal = false" @select="archiveModal($event)" />
	</section>
</template>

<script>
import * as moment from 'moment';
import 'moment/locale/pt-br';
import * as ecAxios from '../../util/ecAxios';
import global from '../../mixins/global';
import TextToInitials from '../../layout/components/miscellaneous/TextToInitials';
import Button from '../../layout/components/buttons/Default';
import Sintegra from '../../layout/components/tags/sintegra';
import OptModal from '../../layout/components/modal/cadoptions';
import Kstatus from '../../layout/components/tags/Kstatus';
import kTag from '../../layout/components/tags/k-tag-simple';
import TimeLine from '../../layout/components/miscellaneous/TimeLine-C';
import KTagCustom from '../../layout/components/tags/k-tag-custom';

export default {
	components: {
		TextToInitials,
		Button,
		Sintegra,
		Kstatus,
		TimeLine,
		OptModal,
		kTag,
		KTagCustom,
	},
	mixins: [global],
	data() {
		return {
			styles: {
				0: 'border: 2px solid #18435d;-webkit-box-shadow: 4px 8px 22px -10px #18435d; box-shadow: 4px 8px 22px -10px #18435d;',
				1: 'border: 2px solid #f7f3c4;-webkit-box-shadow: 4px 8px 22px -10px #f7f3c4; box-shadow: 4px 8px 22px -10px #f7f3c4;',
				2: 'border: 2px solid #cbb3da;-webkit-box-shadow: 4px 8px 22px -10px #cbb3da; box-shadow: 4px 8px 22px -10px #cbb3da;',
				3: 'border: 2px solid #cbb3da;-webkit-box-shadow: 4px 8px 22px -10px #cbb3da; box-shadow: 4px 8px 22px -10px #cbb3da;',
				4: 'border: 2px solid #abdcbc;-webkit-box-shadow: 4px 8px 22px -10px #abdcbc; box-shadow: 4px 8px 22px -10px #abdcbc;',
				5: 'border: 2px solid gray;-webkit-box-shadow: 4px 8px 22px -10px gray; box-shadow: 4px 8px 22px -10px gray;',
				6: 'border: 2px solid #565656;-webkit-box-shadow: 4px 8px 22px -10px #565656; box-shadow: 4px 8px 22px -10px #565656;',
			},
			isOpen: null,
			collapses: [
				{
					title: 'Title 1',
					text: 'Text 1',
				},
				{
					title: 'Title 2',
					text: 'Text 2',
				},
				{
					title: 'Title 3',
					text: 'Text 3',
				},
			],
			data: [],
			cadastro_situacoes_log: {},
			situacaoDesc: {
				'-1': 'Digitando',
				0: 'Recebido',
				1: 'Aprovado',
				2: 'Integrado',
				'-2': 'Análise',
				4: 'Concluído',
			},
			archivedata: {},
			closemodal: false,
			situacaoLog: [],
		};
	},
	created() {
		this.getData();
	},
	methods: {
		retStyles(params) {
			return this.styles[params];
		},
		editAction() {
			if (this.data.situacao !== 1 && this.data.situacao !== 2) {
				this.$router.push(`/precadastro/edit/${this.data.id}`);
			}
		},
		async getSituacoesLog(cadastroId) {
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.EC_USUARIO_CADASTRO_SITUACOES_LOG}`;
				const payload = {
					cadastro_id: cadastroId,
				};
				const { data } = await ecAxios.connection().post(url, payload);

				if (data.error === 0) {
					this.situacaoLog = data.count;
					this.cadastro_situacoes_log = {
						situacaoLog: data.count,
						situacaoDesc: this.situacaoDesc,
					};
				} else {
					this.notification('Ocorreu um erro ao realizar a operação', 'is-danger');
				}
			} catch (e) {
				this.notification(e, 'is-danger');
			}
		},
		archiveModal(option) {
			if (this.archivedata) {
				this.archivedata.motivo = option;
				this.closemodal = false;
				this.handleArchive(this.archivedata);
			}
		},
		async handleArchive(action) {
			if (action.motivo) {
				await ecAxios
					.connection()
					.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_USUARIO_CADASTRO_ARQUIVAR}`, action)
					.then((response) => {
						if (response.status === 200) {
							this.getData();
							this.$buefy.notification.open({
								duration: 5000,
								message: 'Cadastro arquivado com sucesso!',
								position: 'is-bottom',
								type: 'is-success',
							});
						}
					})
					.catch((e) => {
						this.$buefy.notification.open({
							message: e.toString(),
							type: 'is-danger',
						});
					});
			}
		},
		archive(data) {
			if (
				this.data.situacao === 0 ||
				this.data.situacao === -1 ||
				this.data.situacao === 2 ||
				this.data.situacao === 3 ||
				this.data.status === 2
			) {
				this.archivedata = {};
				this.closemodal = true;
				this.archivedata = data;
			}
		},
		getSintegraStatus(data) {
			let { sintegrastatus, receitastatus } = data;
			const sintegraId = sintegrastatus;
			sintegrastatus = parseInt(sintegrastatus, 10);
			if (sintegrastatus === 1) {
				sintegrastatus = 'Liberado';
			} else if (sintegrastatus === 0 && sintegrastatus !== '') {
				sintegrastatus = 'Bloqueado';
			} else {
				sintegrastatus = '';
			}
			if (receitastatus !== '' && receitastatus !== null) {
				receitastatus = ` / ${receitastatus} (RF)`;
				sintegrastatus += receitastatus;
			}
			return { sintegrastatus, sintegraId };
		},
		returnElapsedTime(data) {
			if (data) {
				return moment(data).fromNow();
			}
			return '~';
		},
		async getData() {
			await ecAxios
				.connection()
				.get(
					`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_USUARIO_CADASTRO}${this.$route.params.id}`
				)
				.then((response) => {
					if (response.data.error === 0) {
						this.data = response.data.usuarioCadastro;
						this.data.empresatempo = this.data.dtanascfund;
						this.data.dtanascfund = this.dateToBrasil(this.data.dtanascfund);
						this.data.cnpj = this.formatCnpjCpf(this.data.cnpj);
						this.data.cnpjcpfsocio1 = this.formatCnpjCpf(this.data.cnpjcpfsocio1);
						this.data.cnpjcpfsocio2 = this.formatCnpjCpf(this.data.cnpjcpfsocio2);
						this.data.cnpjcpfsocio3 = this.formatCnpjCpf(this.data.cnpjcpfsocio3);
						this.getSituacoesLog(this.data.id);
						this.collapses = [
							{
								title: 'Endereço',
								text: `${this.data.logradouro},
                 Número ${this.data.numero}, ${this.data.bairro}, 
                 ${this.data.cidade}-${this.data.uf}`,
								children: [
									{
										title: 'Logradouro',
										text: this.data.logradouro,
										icon: 'map-pin',
									},
									{
										title: 'Número',
										text: this.data.numero,
										icon: 'bookmark',
									},
									{
										title: 'Complemento',
										text: this.data.complemento,
										icon: 'git-commit',
									},
									{
										title: 'Bairro',
										text: this.data.bairro,
										icon: 'navigation',
									},
									{
										title: 'Cep',
										text: this.data.cep,
										icon: 'disc',
									},

									{
										title: 'Cidade',
										text: this.data.cidade,
										icon: 'feather',
									},
									{
										title: 'UF',
										text: this.data.uf,
										icon: 'hash',
									},
									{
										title: 'IBGE Cidade',
										text: this.data.codibgecidade,
										icon: 'hash',
									},
									{
										title: 'IBGE UF',
										text: this.data.codibgeuf,
										icon: 'hash',
									},
								],
							},
							{
								title: 'Contato',
								text: null,
								children: [
									{
										title: 'Nome',
										text: this.data.nomecontato,
										icon: 'users',
									},
									{
										title: 'Email',
										text: this.data.email,
										icon: 'mail',
									},
									{
										title: 'Email NFE',
										text: this.data.emailnfe,
										icon: 'mail',
									},
									{
										title: 'Email RCA',
										text: this.data.emailrca,
										icon: 'mail',
									},
									{
										title: 'Telefone 1',
										text: this.data.fone1,
										icon: 'phone-call',
									},
									{
										title: 'Telefone 2',
										text: this.data.fone2,
										icon: 'phone-call',
									},
									{
										title: 'Cod. Representante',
										text: this.data.representante,
										icon: 'hash',
									},
								],
							},
						];
					}
				})
				.catch((e) => {
					this.$buefy.notification.open({
						message: e.toString(),
						type: 'is-danger',
					});
				});
		},
	},
};
</script>

<style scoped>
.log-box {
	width: 50%;
	margin-top: 30px;
	background-color: #fff;
	box-shadow: 0 0.125em 0.25em rgb(10 10 10 / 10%);
	border-radius: 5px;
	padding: 20px;
}
.container-precadastro {
	display: flex;
	width: 100%;
	min-height: 100vh;
	flex-direction: column;
	margin-bottom: 50px;
}
.socios-title {
	width: 100%;
	display: flex;
	font-size: 15px;
	margin-bottom: 20px;
	font-weight: bold;
}
.socio-row span {
	font-size: 12px;
	margin-bottom: 15px;
}
.button-lef-content {
	display: flex;
	align-items: center;
}
.criacao-empresa-box {
	display: flex;
	justify-content: space-between;
	font-size: 10px;
	margin-bottom: 12px;
	align-items: center;
}
.socios-box {
	width: 40%;
	background-color: #fff;
	padding: 20px;
	border-radius: 5px;
	box-shadow: 0 0.125em 0.25em rgb(10 10 10 / 10%);
}
.box-detalhes {
	width: 100%;
	display: flex;
	justify-content: space-between;
	margin-top: 30px;
}
.tag-content-ms {
	background-color: rebeccapurple;
}
.row-collaps-item {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
}
.top-left-content {
	display: flex;
}
.top-left-content {
	display: flex;
}
.rows-details-addres {
	text-align: end;
}
.socios-colapse {
	width: 100%;
}
.box-subtitle-empresa {
	display: flex;
	flex-direction: column;
}
.socio-row {
	display: flex;
	justify-content: space-between;
}
.details-top-title {
	white-space: nowrap;
	font-size: 12px;
	font-weight: bold;
	margin-right: 10px;
}
.resume-empresa h1 {
	margin-bottom: 12px;
	font-size: 12px;

	font-weight: bold;
}
.resume-empresa {
	display: flex;
	flex-direction: column;
	min-width: 60%;
}
.detalhes-box {
	width: 58%;
	background-color: #fff;
	box-shadow: 0 0.125em 0.25em rgb(10 10 10 / 10%);
	border-radius: 5px;
	padding: 20px;
}
.rows-details span {
	white-space: pre-wrap;
}
.row-cad-status {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	width: 100%;
	padding-top: 13px;
	font-size: 12px;
}
.rows-details {
	font-size: 12px;
	display: flex;
	margin-bottom: 10px;
	align-items: center;
	justify-content: space-between;
}
.rows-details-info {
	font-size: 12px;
	display: flex;
	margin-bottom: 10px;
	align-items: flex-start;
	justify-content: space-between;
}
.email_link {
	padding-bottom: 2px;
	font-size: 12px;
	color: #03a9f4 !important;
	/*   border-bottom: 2px solid #3f51b5; */
}
.observacao-text {
	text-align: end;
}
.detais-top-cadastro {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 7px;
}
.empresa-details {
	display: flex;
	padding: 20px;
	background-color: #fff;
	width: 73%;
	justify-content: space-between;
	border-radius: 5px;
	align-items: flex-start;
	box-shadow: 0 0.125em 0.25em rgb(10 10 10 / 10%);
}
.header-empresa {
	width: 100%;
	display: flex;
	justify-content: space-between;
	border-radius: 5px;
}
.card-header-title {
	font-size: 12px;
}
.card-header {
	padding: 0px;
}
.image-component {
	margin-right: 20px;
}
.actions-precadastro {
	background-color: #fff;
	width: 100%;
	height: 50px;
	border-radius: 5px;
	margin-bottom: 20px;
}
.label-buttons {
	display: flex;
}
.right_side {
	display: flex;
	flex-direction: column;
	width: 50%;
	margin-left: 10px;
}
.left_content {
	width: 50%;
	display: flex;
	flex-direction: column;
}
.empresa-resume {
	display: flex;
	background-color: #f3f3f3;
	width: 100%;
	justify-content: space-between;
}
.label-title {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 10px;
}
.icon-label {
	margin-right: 8px;
}
.box-details-cadastro {
	width: 25%;
	background-color: #fff;
	border-radius: 5px;
	padding: 20px;
}
</style>

